<script setup lang="ts">
import { useRouter } from 'vue-router';
import RoundedButton from '@/components/ui/RoundedButton.vue';

const router = useRouter();

function goBack() {
  router.back();
}
</script>

<template>
  <div class="backbutton">
    <RoundedButton
      :aria-label="$t('common.back')"
      class="backbutton__button"
      size="large"
      type="secondary"
      icon="arrow-left"
      @click="goBack"
    />
  </div>
</template>

<style lang="scss">
.backbutton {
  left: $spacing-5;
  position: absolute;
  top: calc(12px + var(--status-bar-band));
  z-index: 2;

  &__button {
    border: 1px solid $color-border-medium;
  }
}
</style>
